import { IConfirmacaoExclusaoTextos } from './confirmacao-exclusao.modal.controller';

export class ConfirmacaoExclusaoModalService {

    static $inject = ['$uibModal'];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) {}

    public open(textos: IConfirmacaoExclusaoTextos): ng.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./confirmacao-exclusao.modal.html'),
            controller: 'ConfirmacaoExclusaoModalController',
            controllerAs: '$ctrl',
            windowClass: '',
            backdrop: 'static',
            resolve: {
                textos: () => textos,
            }
        });
    }
}
